var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "添加文件",
            visible: _vm.dialog.visible,
            "append-to-body": "",
            "modal-append-to-body": false,
            "close-on-click-modal": false,
            width: "50%",
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.dialog, "visible", $event)
            },
            closed: _vm.beforeClose,
          },
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "justify-content": "space-between",
              },
            },
            [
              _c(
                "div",
                { staticStyle: { "margin-left": "20px" } },
                [
                  _c("span", [_vm._v("转码分组：")]),
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择转码分组", size: "mini" },
                      model: {
                        value: _vm.templateGroupValue,
                        callback: function ($$v) {
                          _vm.templateGroupValue = $$v
                        },
                        expression: "templateGroupValue",
                      },
                    },
                    _vm._l(_vm.templateGroup, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                [
                  _c(
                    "el-upload",
                    {
                      attrs: {
                        action: "#",
                        "on-change": _vm.uploadFile,
                        "show-file-list": false,
                        "auto-upload": false,
                        multiple: "",
                      },
                    },
                    [
                      _c(
                        "el-button",
                        { attrs: { size: "small", type: "primary" } },
                        [_vm._v("点击上传")]
                      ),
                      _c("div", {
                        staticClass: "el-upload__tip",
                        attrs: { slot: "tip" },
                        slot: "tip",
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
          _vm.fileInfoList.length === 0
            ? _c(
                "div",
                { staticClass: "upload" },
                [
                  _c(
                    "el-upload",
                    {
                      staticClass: "upload-file-select",
                      attrs: {
                        drag: "",
                        action: "#",
                        "on-change": _vm.uploadFile,
                        "show-file-list": false,
                        "auto-upload": false,
                        multiple: "",
                      },
                    },
                    [
                      _c("i", { staticClass: "el-icon-upload" }),
                      _c("div", { staticClass: "el-upload__text" }, [
                        _vm._v("\n          将文件拖拽到此处，或"),
                        _c("em", [_vm._v("点击上传")]),
                      ]),
                      _c("div", {
                        staticClass: "el-upload__tip",
                        attrs: { slot: "tip" },
                        slot: "tip",
                      }),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            { staticClass: "file-container" },
            _vm._l(_vm.fileInfoList, function (item) {
              return _c("div", { key: item.fileId, staticClass: "file-list" }, [
                _c("div", [
                  _c("span", { staticClass: "file-name" }, [
                    _vm._v(_vm._s(item.filename)),
                  ]),
                ]),
                _c("div", { staticClass: "file-info" }, [
                  _c("span", [_vm._v("格式：" + _vm._s(item.fileExt))]),
                  _vm._v("   "),
                  _c("span", [
                    _vm._v(
                      "分辨率：" +
                        _vm._s(
                          item.media.videoWidth + "x" + item.media.videoHeight
                        )
                    ),
                  ]),
                  _vm._v("   "),
                  _c("span", [
                    _vm._v("时长：" + _vm._s(item.media.videoDuration)),
                  ]),
                  _vm._v("   "),
                  _c("span", [
                    _vm._v("文件大小：" + _vm._s(item.fileSize + "M")),
                  ]),
                ]),
                _c("div", [
                  item.status === "ready"
                    ? _c("span", [
                        _vm._v("等待上传"),
                        _c(
                          "span",
                          {
                            staticClass: "cancel-icon",
                            on: {
                              click: function ($event) {
                                return _vm.handleCancelReady(item)
                              },
                            },
                          },
                          [_vm._v("×")]
                        ),
                      ])
                    : _vm._e(),
                  item.status === "uploading"
                    ? _c("span", { staticClass: "file-percent" }, [
                        _vm._v(
                          "上传进度：" + _vm._s(item.uploadProgress + "%")
                        ),
                      ])
                    : _vm._e(),
                  item.status === "cancel"
                    ? _c("span", [_vm._v("已取消上传 ")])
                    : _vm._e(),
                  item.status === "failed"
                    ? _c("span", { staticStyle: { color: "red" } }, [
                        _vm._v("上传失败\n          "),
                      ])
                    : _vm._e(),
                  item.status === "finished"
                    ? _c("span", { staticStyle: { color: "#3dcc55" } }, [
                        _vm._v("上传成功"),
                      ])
                    : _vm._e(),
                  item.status === "uploading" && item.uploadProgress != 0
                    ? _c(
                        "span",
                        {
                          staticClass: "cancel-icon",
                          on: {
                            click: function ($event) {
                              return _vm.handleCancelUpload(item)
                            },
                          },
                        },
                        [_vm._v("×")]
                      )
                    : _vm._e(),
                ]),
              ])
            }),
            0
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }